import $ from "jquery";

import "../scss/page.scss";

import "../scss/blog.scss";